// Author YuJiaBei
// Date 2022-04-07 21:06:18

class EmOpcComputedActionEoca {
constructor({
        eocaName = '',
        id = null,
        eocaIdEoc = '',
        eocaTarget = '',
        eocaOperatorTarget = '',
        eocaFactorAType = '',
        eocaFactorAPosition = '',
        eocaFactorA = '',
        eocaOperator = '',
        eocaFactorBType = '',
        eocaFactorBPosition = '',
        eocaFactorB = '',
        eocaEnable = '',
        remark = ''}
= {}) {
    this.eocaName = eocaName;
    this.id = id;
    this.eocaIdEoc = eocaIdEoc;
    this.eocaTarget = eocaTarget;
    this.eocaOperatorTarget = eocaOperatorTarget;
    this.eocaFactorAType = eocaFactorAType;
    this.eocaFactorAPosition = eocaFactorAPosition;
    this.eocaFactorA = eocaFactorA;
    this.eocaOperator = eocaOperator;
    this.eocaFactorBType = eocaFactorBType;
    this.eocaFactorBPosition = eocaFactorBPosition;
    this.eocaFactorB = eocaFactorB;
    this.eocaEnable = eocaEnable;
    this.remark = remark;
}
}

function newEntity() {
return new EmOpcComputedActionEoca();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocaName',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocaName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocaIdEoc',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocaIdEoc',
        sortable: true,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
        }
        },
        {
        key: 'eocName',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocNodeId',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocNodeId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocValueType',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocValueType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocEnable',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocEnable',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocaTarget',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocaTarget',
        sortable: true,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
        }
        },
        {
        key: 'eocaOperatorTarget',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocaOperatorTarget',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: ' = ' },
                            { value: '2', text: ' + ' },
                            { value: '3', text: ' - ' },
                            { value: '4', text: ' * ' },
                            { value: '5', text: ' / ' },
                            { value: '6', text: ' 绝对值 ' }
            ]
        }
        },
        {
        key: 'eocaFactorAType',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocaFactorAType',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: ' 值 ' },
                            { value: '2', text: ' 自己新 ' },
                            { value: '3', text: ' 引用新 ' },
                            { value: '4', text: ' 自己旧 ' },
                            { value: '5', text: ' 引用旧 ' }
            ]
        }
        },
        {
        key: 'eocaFactorA',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocaFactorA',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocaFactorAPosition',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocaFactorAPosition',
        sortable: true,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocaOperator',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocaOperator',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: ' = ' },
                            { value: '2', text: ' + ' },
                            { value: '3', text: ' - ' },
                            { value: '4', text: ' * ' },
                            { value: '5', text: ' / ' },
                            { value: '6', text: ' 绝对值 ' }
            ]
        }
        },
        {
        key: 'eocaFactorBType',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocaFactorBType',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: ' 值 ' },
                            { value: '2', text: ' 自己新 ' },
                            { value: '3', text: ' 引用新 ' },
                            { value: '4', text: ' 自己旧 ' },
                            { value: '5', text: ' 引用旧 ' }
            ]
        }
        },
        {
        key: 'eocaFactorB',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocaFactorB',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocaFactorBPosition',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocaFactorBPosition',
        sortable: true,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocaEnable',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.eocaEnable',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    eocaNameFilter : '',
    idFilter : '',
    idListFilter : [],
    eocaIdEocFilter : '',
    eocEnableFilter : '',
    eocaTargetFilter : '',
    eocaOperatorTargetFilter : '',
    eocaFactorATypeFilter : '',
    eocaFactorAFilter : '',
    eocaOperatorFilter : '',
    eocaFactorBTypeFilter : '',
    eocaFactorBFilter : '',
    eocaEnableFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'eocaNameFilter',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.filter.eocaName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eocaIdEocFilter',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.filter.eocaIdEoc',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eocEnableFilter',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.filter.eocEnable',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eocaTargetFilter',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.filter.eocaTarget',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'eocNodeId'
                }
        },
        {
        key: 'eocaOperatorTargetFilter',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.filter.eocaOperatorTarget',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: ' = ' },
                { value: '2', text: ' + ' },
                { value: '3', text: ' - ' },
                { value: '4', text: ' * ' },
                { value: '5', text: ' / ' },
                { value: '6', text: ' 绝对值 ' }
            ]
        }
        },
        {
        key: 'eocaFactorATypeFilter',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.filter.eocaFactorAType',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: ' 值 ' },
                { value: '2', text: ' 自己新 ' },
                { value: '3', text: ' 引用新 ' },
                { value: '4', text: ' 自己旧 ' },
                { value: '5', text: ' 引用旧 ' }
            ]
        }
        },
        {
        key: 'eocaFactorAFilter',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.filter.eocaFactorA',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eocaOperatorFilter',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.filter.eocaOperator',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: ' = ' },
                { value: '2', text: ' + ' },
                { value: '3', text: ' - ' },
                { value: '4', text: ' * ' },
                { value: '5', text: ' / ' },
                { value: '6', text: ' 绝对值 ' }
            ]
        }
        },
        {
        key: 'eocaFactorBTypeFilter',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.filter.eocaFactorBType',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: ' 值 ' },
                { value: '2', text: ' 自己新 ' },
                { value: '3', text: ' 引用新 ' },
                { value: '4', text: ' 自己旧 ' },
                { value: '5', text: ' 引用旧 ' }
            ]
        }
        },
        {
        key: 'eocaFactorBFilter',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.filter.eocaFactorB',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eocaEnableFilter',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.filter.eocaEnable',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'eocaName',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.entity.eocaName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eocaIdEoc',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.entity.eocaIdEoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eocaTarget',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.entity.eocaTarget',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'eocNodeId'
                }
        },
        {
        key: 'eocaOperatorTarget',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.entity.eocaOperatorTarget',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: ' = ' },
                { value: '2', text: ' + ' },
                { value: '3', text: ' - ' },
                { value: '4', text: ' * ' },
                { value: '5', text: ' / ' },
                { value: '6', text: ' 绝对值 ' }
            ]
        }
        },
        {
        key: 'eocaFactorAType',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.entity.eocaFactorAType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: ' 值 ' },
                { value: '2', text: ' 自己新 ' },
                { value: '3', text: ' 引用新 ' },
                { value: '4', text: ' 自己旧 ' },
                { value: '5', text: ' 引用旧 ' }
            ]
        }
        },
        {
        key: 'eocaFactorAPosition',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.entity.eocaFactorAPosition',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eocaFactorA',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.entity.eocaFactorA',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eocaOperator',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.entity.eocaOperator',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: ' = ' },
                { value: '2', text: ' + ' },
                { value: '3', text: ' - ' },
                { value: '4', text: ' * ' },
                { value: '5', text: ' / ' },
                { value: '6', text: ' 绝对值 ' }
            ]
        }
        },
        {
        key: 'eocaFactorBType',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.entity.eocaFactorBType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: ' 值 ' },
                { value: '2', text: ' 自己新 ' },
                { value: '3', text: ' 引用新 ' },
                { value: '4', text: ' 自己旧 ' },
                { value: '5', text: ' 引用旧 ' }
            ]
        }
        },
        {
        key: 'eocaFactorBPosition',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.entity.eocaFactorBPosition',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eocaFactorB',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.entity.eocaFactorB',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eocaEnable',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.entity.eocaEnable',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcComputedActionEoca.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {EmOpcComputedActionEoca, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
